//ΔVΔVΔ: this is probably a stop gap solution
import axios from 'axios';
import { getTimePeriodObject, getScaleObject } from '../store/StaticVariables';
import { mapFeatureServiceObjectToMapServiceObject, geometryScaleFromGeoid, standardizeObjectKeys } from '../utils/DataTransformation';
import { endpoints } from '../store/StaticVariables';

const baseUrl = (time, scaleID) => endpoints.features + time.toUpperCase() + `/MapServer/${scaleID}/query`;

export const ReloadSelectedFeatureRequest = async (args) => {
    const { feature, time, token = '' } = args;
    const timeAttr = getTimePeriodObject(time).attr;
    const scaleFromFeature = geometryScaleFromGeoid(feature.GEOID);
    const scaleID = getScaleObject(scaleFromFeature).id;
    const serviceURL = baseUrl(timeAttr, scaleID);
    const tokenText = endpoints.useToken && token ? '&token=' + token : '';

    const url = `${serviceURL}/query?where=GEOID%3D%27${feature.GEOID}%27&outFields=*&returnGeometry=false&f=pjson${tokenText}`;
    return axios.get(url).then((res) => {
        if (res.data.error) throw new Error('ERROR in Reload Selected Feature Request', { cause: res.data.error });
        const feature = res?.data?.features?.[0].attributes;
        // return feature ? mapFeatureServiceObjectToMapServiceObject(feature) : false;
        return feature ? standardizeObjectKeys(feature) : false;
    });
};
